/* GraceYes — a small celebration when something lands in the bag.

   Firework-style bursts drawn on one full-screen canvas that ignores clicks.
   How much goes off depends on what was added:
     level 1  one item                         one burst from the button
     level 2  two of something, or adding to   two bursts
              a bag that already has items
     level 3  a pack of 3, or a whole routine   a run of bursts across the screen
   Adding to a bag that is not empty lifts the level by one.

   It only fires once the bag count in the header has actually gone up, so a
   failed add (sold out, network) celebrates nothing. Nothing runs for visitors
   who have asked their device for reduced motion. Loaded from
   snippets/gy-cart.liquid; window.GYFx.celebrate(level) is there for testing. */
(function () {
  'use strict';
  if (!window.requestAnimationFrame || !document.addEventListener) { return; }
  var calm = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var COLORS = ['#C29B38', '#2B4436', '#5C2433', '#E7C873', '#F3E9D2', '#7FA58C'];
  var canvas = null, ctx = null, parts = [], running = false;
  var dpr = Math.min(2, window.devicePixelRatio || 1);

  function size() {
    canvas.width = window.innerWidth * dpr;
    canvas.height = window.innerHeight * dpr;
    ctx.setTransform(dpr, 0, 0, dpr, 0, 0);
  }
  function ensure() {
    if (canvas) { return; }
    canvas = document.createElement('canvas');
    canvas.setAttribute('aria-hidden', 'true');
    canvas.style.cssText = 'position:fixed;left:0;top:0;width:100%;height:100%;pointer-events:none;z-index:2147483647';
    document.body.appendChild(canvas);
    ctx = canvas.getContext('2d');
    size();
    window.addEventListener('resize', size);
  }

  function burst(x, y, count, power) {
    for (var i = 0; i < count; i++) {
      var a = Math.random() * Math.PI * 2;
      var s = power * (0.35 + Math.random() * 0.65);
      parts.push({
        x: x, y: y, vx: Math.cos(a) * s, vy: Math.sin(a) * s - power * 0.3,
        g: 0.12 + Math.random() * 0.08, life: 0, ttl: 55 + Math.random() * 40,
        size: 3 + Math.random() * 4, rot: Math.random() * 6.28, vr: (Math.random() - 0.5) * 0.4,
        c: COLORS[(Math.random() * COLORS.length) | 0], round: Math.random() < 0.4
      });
    }
    if (!running) { running = true; window.requestAnimationFrame(loop); }
  }
  function loop() {
    ctx.clearRect(0, 0, window.innerWidth, window.innerHeight);
    parts = parts.filter(function (p) {
      p.life++;
      p.vx *= 0.985; p.vy = p.vy * 0.985 + p.g;
      p.x += p.vx; p.y += p.vy; p.rot += p.vr;
      var alpha = 1 - Math.pow(p.life / p.ttl, 3);
      if (alpha <= 0) { return false; }
      ctx.save();
      ctx.globalAlpha = alpha;
      ctx.translate(p.x, p.y);
      ctx.rotate(p.rot);
      ctx.fillStyle = p.c;
      if (p.round) { ctx.beginPath(); ctx.arc(0, 0, p.size / 2, 0, Math.PI * 2); ctx.fill(); }
      else { ctx.fillRect(-p.size / 2, -p.size / 4, p.size, p.size / 2); }
      ctx.restore();
      return true;
    });
    if (parts.length) { window.requestAnimationFrame(loop); }
    else { running = false; ctx.clearRect(0, 0, window.innerWidth, window.innerHeight); }
  }

  function celebrate(level, origin) {
    if (calm) { return; }
    ensure();
    var w = window.innerWidth, h = window.innerHeight;
    var ox = w / 2, oy = h * 0.45;
    if (origin && origin.x > 0 && origin.x < w && origin.y > 0 && origin.y < h) { ox = origin.x; oy = origin.y; }
    if (level <= 1) {
      burst(ox, oy, 40, 7);
    } else if (level === 2) {
      burst(ox, oy, 60, 8.5);
      window.setTimeout(function () { burst(w * 0.5, h * 0.3, 55, 8); }, 190);
    } else {
      burst(ox, oy, 80, 9.5);
      [0.2, 0.8, 0.5, 0.33, 0.67].forEach(function (fx, i) {
        window.setTimeout(function () { burst(w * fx, h * (0.2 + 0.13 * (i % 2)), 70, 9); }, 170 + i * 180);
      });
    }
  }
  window.GYFx = { celebrate: celebrate };

  /* ------------------------------------------------------------- wiring */
  var pending = null, lastCount = null;
  function bagCount() {
    var b = document.querySelector('.gy-header__count');
    return b ? (parseInt(b.textContent, 10) || 0) : null;
  }
  function note(level, el) {
    var r = el && el.getBoundingClientRect ? el.getBoundingClientRect() : null;
    var count = bagCount();
    pending = { level: level, at: Date.now(), had: count || 0,
                origin: r ? { x: r.left + r.width / 2, y: r.top + r.height / 2 } : null };
    /* No header badge to watch on this page: celebrate on a short delay. */
    if (count === null) { window.setTimeout(fire, 900); }
  }
  function fire() {
    if (!pending) { return; }
    var p = pending; pending = null;
    if (Date.now() - p.at > 10000) { return; }
    var level = p.level;
    if (p.had > 0 && level < 3) { level++; }
    celebrate(level, p.origin);
  }

  /* Capture phase: this only takes note of what is being added. The bag's own
     listeners (assets/gy-cart.js) do the adding. */
  document.addEventListener('submit', function (ev) {
    var f = ev.target;
    if (!f || f.tagName !== 'FORM') { return; }
    if ((f.getAttribute('action') || '').indexOf('/cart/add') === -1) { return; }
    var field = f.querySelector('[name="quantity"]') || (f.id ? document.querySelector('[name="quantity"][form="' + f.id + '"]') : null);
    var q = field ? (Number(field.value) || 1) : 1;
    note(q >= 3 ? 3 : (q === 2 ? 2 : 1), f.querySelector('button[type="submit"]') || f);
  }, true);

  document.addEventListener('click', function (ev) {
    var t = ev.target && ev.target.closest ? ev.target.closest('[data-gy-add-set], .gyc-pack[data-gyc-set]') : null;
    if (!t) { return; }
    if (t.hasAttribute('data-gy-add-set')) {
      var lines = t.getAttribute('data-gy-add-set').split(',').length;
      note(lines >= 2 ? 3 : 1, t);
    } else {
      var q = Number((t.getAttribute('data-gyc-set') || '').split(':')[1]) || 2;
      note(q >= 3 ? 3 : 2, t);
    }
  }, true);

  function watch() {
    var b = document.querySelector('.gy-header__count');
    if (!b || !('MutationObserver' in window)) { return; }
    lastCount = bagCount();
    new MutationObserver(function () {
      var c = bagCount();
      if (c > lastCount) { fire(); }
      lastCount = c;
    }).observe(b, { childList: true, characterData: true, subtree: true });
  }
  if (document.readyState === 'loading') { document.addEventListener('DOMContentLoaded', watch); } else { watch(); }
})();
